import styled from 'styled-components';
import { Input } from 'antd';

export const TextInput = styled(Input)`
`;
